// @ts-nocheck
import React, { useState } from "react";
import { useDifusiones } from "../context/DifusionesContext";
import { useBody } from "../../Body/state/BodyContext";
import { Modal, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export const BorrarListaModal = ({ open, onClose, listaSeleccionada, onSuccess }) => {
    const { eliminarLista } = useDifusiones();
    const { setSuccess, setMessage } = useBody();
    const [loading, setLoading] = useState(false);

    const handleEliminar = async () => {
        setLoading(true);
        try {
            await eliminarLista(listaSeleccionada.id);
            setSuccess("Lista eliminada exitosamente");
            onSuccess(listaSeleccionada.id);
            onClose();
        } catch (error) {
            console.error("Error al eliminar la lista:", error);
            setMessage("Error al eliminar la lista");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Root>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <DeleteOutlineIcon color="error" />
                        <Typography variant="h6">Eliminar lista</Typography>
                    </Box>

                    <Typography variant="body1" color="text.secondary">
                        ¿Seguro que querés eliminar <strong>{listaSeleccionada?.nombre}</strong>? Esta acción no puede revertirse.
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="error"
                            disabled={loading}
                            onClick={handleEliminar}
                        >
                            {loading ? 'Eliminando...' : 'Eliminar'}
                        </Button>
                    </Box>
                </Box>
            </Root>
        </Modal>
    );
};
